import React, {useState, useEffect} from "react";

export default function SoftshelljackePrimoPlusBack({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(darkContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <g>
        <path
          fill={lightContrast}
          onClick={() => handleClick("base")}
          onMouseEnter={() => setLightContrastActive(true)}
          onMouseLeave={() => setLightContrastActive(false)}
          style={
            lightContrastActive && !preview
              ? {fill: adjust(lightContrast, 55)}
              : {fill: lightContrast}
          }
          d="M477.687,460.215c-1.402-21.633-3.356-47.176-7.116-72.851c-1.479-10.105-2.456-20.383-3.401-30.336
   c-0.512-5.259-1.022-10.692-1.609-16.049c-0.456-4.172-1.304-8.376-2.13-12.44c-0.489-2.401-0.989-4.879-1.402-7.323
   c-1.792-10.583-3.705-21.405-5.682-32.174c-1.228-6.65-2.413-13.343-3.554-19.829c-4.193-23.85-8.17-46.372-14.635-69.635
   c-7.194-25.871-16.832-53.556-26.446-75.982c-4.792-11.18-11.311-21.427-14.81-26.935c-1.424-2.227-2.652-4.151-2.696-4.51h-0.249
   l0.108-0.097c-0.966-0.99-1.043-1.054-1.402-1.239c-0.174-0.087-0.423-0.217-0.978-0.587
   c-26.38-17.961-85.804-35.573-90.563-36.965c0.337-2.248,1.999-15.298-4.107-20.872c-6.855-6.257-22.73-12.767-42.473-13.32v-0.022
   c-0.336,0-0.662,0-0.989-0.012h-0.216c-0.414-0.01-0.815-0.01-1.217-0.01c-0.902,0-1.804,0-2.728,0.022v0.022
   c-19.753,0.576-35.616,7.063-42.484,13.32c-6.106,5.574-4.443,18.624-4.107,20.872c-4.759,1.392-64.181,19.005-90.562,36.965
   c-0.554,0.369-0.805,0.5-0.967,0.587c-0.359,0.185-0.445,0.249-1.402,1.239l0.098,0.097h-0.24c-0.054,0.36-1.282,2.283-2.693,4.51
   c-3.511,5.509-10.03,15.755-14.82,26.935c-9.606,22.426-19.243,50.111-26.435,75.982c-6.476,23.252-10.443,45.775-14.648,69.625
   c-1.141,6.476-2.314,13.18-3.541,19.839c-1.989,10.79-3.901,21.612-5.695,32.174c-0.413,2.445-0.913,4.922-1.391,7.323
   c-0.826,4.064-1.673,8.268-2.13,12.44c-0.587,5.346-1.107,10.779-1.607,16.026c-0.946,9.953-1.935,20.243-3.413,30.359
   c-3.747,25.664-5.704,51.218-7.117,72.842c-0.152,0.13-0.249,0.315-0.272,0.532c-0.021,0.348,0.174,0.652,0.479,0.759
   c21.774,7.519,36.637,9.54,46.34,9.54c4.988,0,8.617-0.531,11.115-1.14c0.034-0.011,0.88-0.424,1.239-1.522
   c0.098-0.52,8.779-52.305,11.908-61.052c2.652-7.388,20.352-72.744,22.622-85.293c1.467-8.008,6.184-24.904,10.735-41.234
   c0.685-2.445,1.358-4.868,2.032-7.27c3.988,48.591,7.562,97.377,6.976,110.057c-0.151,3.291-0.281,6.682-0.413,10.105v0.011
   c-0.879,24.751-1.021,50.817-1.032,51.122c0.011,0.912,0.782,22.501,53.318,36.79c15.027,3.042,30.835,4.65,48.317,4.922
   c4.303,0.065,8.487,0.109,12.593,0.109c21.807,0,41.06-1.108,60.477-5.031c52.503-14.289,53.274-35.879,53.284-36.801
   c0-0.293-0.141-26.349-1.032-51.101v-0.021c-0.118-3.423-0.26-6.814-0.413-10.105c-0.576-12.68,2.988-61.466,6.987-110.057
   c0.662,2.39,1.335,4.804,2.01,7.227c4.563,16.351,9.289,33.259,10.745,41.278c2.283,12.55,19.983,77.905,22.622,85.293
   c3.129,8.747,11.822,60.531,11.919,61.107c0.349,1.043,1.196,1.456,1.304,1.499c2.468,0.587,6.063,1.107,11.018,1.107
   c9.681,0,24.557-2.009,46.375-9.54c0.303-0.108,0.489-0.412,0.466-0.759C477.949,460.52,477.839,460.335,477.687,460.215z"
        />
        <path
          fill="#EAEAEA"
          d="M220.025,425.359c-37.833-3.347-55.175-12.365-56.956-13.332l-0.327-6.659
   c-0.281-5.759-0.52-12.083-0.749-18.797c6.681,5.943,14.548,10.821,25.316,17.492C195.98,409.442,206.715,416.102,220.025,425.359"
        />
        <path
          fill="#EAEAEA"
          d="M341.934,386.57c-0.216,6.715-0.456,13.038-0.749,18.785l-0.326,6.672
   c-1.771,0.966-19.124,9.984-56.956,13.331c13.321-9.256,24.055-15.917,32.727-21.295
   C327.385,397.391,335.253,392.514,341.934,386.57"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M363.818,383.614c0.141,3.292,0.282,6.693,0.402,10.106c-0.065,7.247-19.199,16.373-22.633,17.959
   l0.304-6.279c0.716-14.517,1.172-32.554,1.652-51.643c0.598-23.589,1.217-47.983,2.369-66.235l0.022-0.392
   c1.161-18.264,2.358-37.137,7.496-55.164c5.999-21.035,14.581-42.776,26.947-68.278
   C378.497,184.038,362.622,357.885,363.818,383.614"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M459.162,308.719l-0.826-1.01c-6.356-7.78-23.589-17.113-25.458-18.113
   c-0.576-4.444-11.627-86.673-42.778-161.047c-0.531-1.271-1.27-2.532-2.173-3.825c2.967-16.363,5.303-28.577,5.901-31.705
   c0.39,0.739,1.161,1.956,2.476,4.02c3.488,5.487,9.997,15.701,14.767,26.838c9.594,22.394,19.221,50.045,26.403,75.884
   c6.465,23.23,10.431,45.743,14.625,69.582c1.141,6.476,2.325,13.18,3.553,19.829C456.848,295.692,458.021,302.222,459.162,308.719"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M393.263,92.237c-0.283,1.478-2.727,14.136-5.91,31.684c-0.413-0.554-0.858-1.107-1.348-1.662
   c-14.19-16.244-41.027-19.895-58.793-22.307c-53.349-7.247-101.863-7.79-144.184-1.63c-17.635,2.564-47.156,6.867-62.877,21.645
   c-0.794,0.738-1.543,1.509-2.217,2.291c-0.49,0.555-0.935,1.108-1.358,1.662c-3.185-17.548-5.617-30.217-5.901-31.684
   c0.63-0.641,0.685-0.674,0.925-0.792c0.174-0.099,0.445-0.24,1.042-0.631c27.208-18.536,89.814-36.714,90.65-36.964
   c0.554-0.109,23.578-4.607,46.114-4.803l0.01,0.023l2.217-0.034c0.967,0.011,1.935,0.011,2.891,0.034v-0.034
   c22.534,0.196,45.558,4.705,46.112,4.813c0.838,0.25,63.444,18.428,90.661,36.964c0.587,0.391,0.858,0.532,1.043,0.631
   C392.567,91.563,392.622,91.596,393.263,92.237"
        />
        <path
          fill="#EAEAEA"
          d="M384.452,140.164c-0.61,3.455-1.229,6.996-1.858,10.605c-29.282-23.927-114.608-23.938-130.602-23.719
   c-15.853-0.218-101.331-0.239-130.656,23.719c-0.619-3.608-1.24-7.149-1.847-10.605c1.596-1.814,3.531-3.564,5.758-5.215
   c9.302-6.856,20.916-10.387,30.011-12.702c10.962-2.793,22.948-4.748,37.703-6.15c11.06-1.054,22.479-1.663,34.9-1.858
   c9.311-0.152,18.786-0.098,27.946-0.043c4.889,0.033,9.789,0.065,14.678,0.065h0.49c14.647,0,28.857,0.685,42.223,2.043
   c16.7,1.695,29.891,4.106,41.537,7.606C364.492,126.842,376.683,131.331,384.452,140.164"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M162.352,411.679c-3.444-1.586-22.612-10.735-22.644-17.971c0.12-3.422,0.26-6.802,0.413-10.094
   c1.184-25.729-14.69-199.576-16.559-219.927c12.365,25.501,20.937,47.243,26.935,68.278c5.15,18.037,6.345,36.921,7.497,55.186
   l0.022,0.368c1.163,18.254,1.771,42.637,2.368,66.225c0.479,19.091,0.936,37.138,1.653,51.655L162.352,411.679z"
        />
        <path
          fill={darkContrast}
          onClick={() => handleClick("contrast")}
          onMouseEnter={() => setDarkContrastActive(true)}
          onMouseLeave={() => setDarkContrastActive(false)}
          style={
            darkContrastActive && !preview
              ? {fill: adjust(darkContrast, 55)}
              : {fill: darkContrast}
          }
          d="M116.011,124.725c-0.913,1.292-1.652,2.553-2.184,3.825c-31.14,74.374-42.19,156.602-42.777,161.047
   c-1.858,1-19.101,10.333-25.447,18.113l-0.826,1.01c1.141-6.487,2.305-13.028,3.51-19.547c1.228-6.66,2.401-13.364,3.553-19.851
   c4.194-23.829,8.16-46.331,14.615-69.56c7.192-25.839,16.808-53.49,26.413-75.884c4.77-11.137,11.267-21.351,14.766-26.838
   c1.315-2.064,2.075-3.281,2.477-4.02C110.708,96.148,113.045,108.36,116.011,124.725"
        />
        <path
          fill="#010101"
          d="M477.687,460.215c-1.402-21.633-3.356-47.176-7.116-72.851c-1.479-10.105-2.456-20.383-3.401-30.336
   c-0.512-5.259-1.022-10.692-1.609-16.049c-0.456-4.172-1.304-8.376-2.13-12.44c-0.489-2.401-0.989-4.879-1.402-7.323
   c-1.792-10.583-3.705-21.405-5.682-32.174c-1.228-6.65-2.413-13.343-3.554-19.829c-4.193-23.85-8.17-46.372-14.635-69.635
   c-7.194-25.871-16.832-53.556-26.446-75.982c-4.792-11.181-11.311-21.427-14.81-26.935c-1.424-2.227-2.652-4.151-2.696-4.51h-0.249
   l0.108-0.097c-0.966-0.99-1.043-1.054-1.402-1.239c-0.174-0.087-0.423-0.217-0.978-0.587
   c-26.38-17.961-85.804-35.573-90.563-36.965c0.337-2.248,1.999-15.298-4.107-20.872c-6.855-6.257-22.73-12.767-42.473-13.32v-0.022
   c-0.336,0-0.662,0-0.989-0.012h-0.216c-0.414-0.01-0.815-0.01-1.217-0.01c-0.902,0-1.804,0-2.728,0.022v0.022
   c-19.753,0.576-35.616,7.063-42.484,13.32c-6.106,5.574-4.443,18.624-4.107,20.872c-4.759,1.392-64.181,19.005-90.562,36.965
   c-0.554,0.369-0.805,0.5-0.967,0.587c-0.359,0.185-0.445,0.249-1.402,1.239l0.098,0.097h-0.24c-0.054,0.36-1.282,2.283-2.694,4.51
   c-3.511,5.509-10.03,15.755-14.82,26.935c-9.606,22.426-19.243,50.111-26.436,75.982c-6.476,23.252-10.443,45.775-14.648,69.625
   c-1.141,6.476-2.314,13.18-3.541,19.839c-1.989,10.79-3.901,21.612-5.695,32.174c-0.413,2.445-0.913,4.922-1.391,7.323
   c-0.826,4.064-1.673,8.267-2.13,12.44c-0.587,5.346-1.107,10.778-1.607,16.026c-0.946,9.953-1.935,20.243-3.413,30.359
   c-3.747,25.664-5.704,51.218-7.117,72.842c-0.152,0.13-0.249,0.315-0.272,0.532c-0.021,0.348,0.174,0.652,0.479,0.759
   c21.774,7.519,36.637,9.54,46.34,9.54c4.988,0,8.617-0.531,11.115-1.14c0.034-0.011,0.88-0.424,1.239-1.522
   c0.098-0.52,8.779-52.305,11.908-61.052c2.652-7.388,20.352-72.744,22.622-85.293c1.467-8.008,6.184-24.904,10.735-41.234
   c0.685-2.445,1.358-4.868,2.032-7.27c3.988,48.591,7.562,97.377,6.976,110.057c-0.151,3.291-0.281,6.682-0.413,10.105v0.011
   c-0.879,24.751-1.021,50.817-1.032,51.122c0.011,0.912,0.782,22.501,53.318,36.79c15.027,3.042,30.835,4.65,48.317,4.922
   c4.303,0.065,8.487,0.109,12.593,0.109c21.807,0,41.06-1.108,60.477-5.031c52.503-14.289,53.274-35.879,53.284-36.801
   c0-0.293-0.141-26.349-1.032-51.101v-0.021c-0.118-3.423-0.26-6.814-0.413-10.105c-0.576-12.68,2.988-61.466,6.988-110.057
   c0.662,2.39,1.335,4.804,2.01,7.227c4.563,16.351,9.289,33.259,10.745,41.278c2.283,12.55,19.983,77.905,22.622,85.293
   c3.129,8.747,11.822,60.531,11.919,61.107c0.349,1.043,1.196,1.456,1.304,1.499c2.468,0.587,6.063,1.107,11.018,1.107
   c9.681,0,24.557-2.009,46.375-9.54c0.303-0.108,0.489-0.412,0.466-0.759C477.949,460.52,477.839,460.335,477.687,460.215
    M393.829,93.02c0.39,0.739,1.162,1.956,2.476,4.019c3.488,5.488,9.996,15.702,14.767,26.839
   c9.594,22.394,19.22,50.045,26.403,75.883c6.465,23.23,10.43,45.744,14.625,69.583c1.14,6.475,2.324,13.179,3.552,19.829
   c1.196,6.519,2.37,13.048,3.511,19.547l-0.826-1.01c-6.357-7.78-23.589-17.113-25.459-18.113
   c-0.575-4.445-11.626-86.673-42.777-161.048c-0.531-1.27-1.271-2.532-2.173-3.824C390.895,108.36,393.231,96.148,393.829,93.02
    M207.389,32.912c4.944-4.509,19.84-12.658,42.45-13.158c0.13,0,0.251,0,0.369-0.011c0.587-0.011,1.185-0.011,1.783-0.011
   c0.466,0,0.922,0,1.379,0.011c0.261,0,0.512,0,0.771,0.011c22.558,0.51,37.465,8.649,42.398,13.158
   c5.725,5.225,4.216,17.905,3.89,20.188c-3.173-0.61-26.664-4.945-48.776-4.771c-21.926-0.087-45.005,4.161-48.154,4.771
   C203.172,50.817,201.662,38.137,207.389,32.912 M111.6,91.444c0.174-0.099,0.445-0.24,1.043-0.63
   c27.207-18.537,89.813-36.714,90.649-36.965c0.554-0.108,23.579-4.607,46.114-4.801l0.011,0.022l2.217-0.033
   c0.966,0.011,1.934,0.011,2.89,0.033v-0.033c22.534,0.194,45.558,4.705,46.112,4.812c0.838,0.251,63.444,18.428,90.662,36.965
   c0.587,0.39,0.858,0.531,1.043,0.63c0.228,0.118,0.281,0.152,0.922,0.793c-0.282,1.478-2.727,14.135-5.91,31.684
   c-0.413-0.554-0.858-1.108-1.347-1.664c-14.191-16.244-41.028-19.893-58.794-22.307c-53.348-7.247-101.863-7.79-144.184-1.63
   c-17.635,2.564-47.155,6.867-62.877,21.645c-0.794,0.739-1.543,1.51-2.217,2.291c-0.489,0.555-0.935,1.109-1.358,1.664
   c-3.185-17.549-5.617-30.218-5.901-31.684C111.305,91.596,111.36,91.563,111.6,91.444 M316.259,403.466
   c-8.898,5.519-19.96,12.376-33.758,22.013c-7.019,0.587-14.735,0.966-23.166,1.076v-0.076c-2.477,0.053-4.889,0.087-7.257,0.109
   c-2.445-0.022-4.923-0.045-7.475-0.109l-0.012,0.076c-8.421-0.11-16.134-0.489-23.153-1.076c-13.8-9.638-24.86-16.495-33.76-22.013
   c-10.996-6.823-18.971-11.767-25.708-17.863c-0.326-9.943-0.598-20.732-0.879-31.879c-0.598-23.589-1.207-47.982-2.369-66.246
   l-0.023-0.371c-1.163-18.307-2.358-37.235-7.519-55.327c-6.15-21.567-14.993-43.852-27.837-70.146l-0.238-0.511
   c-0.543-3.216-1.087-6.411-1.63-9.563c27.532-22.969,106.99-23.979,127.94-23.828v0.077c0.087-0.011,0.977-0.034,2.532-0.054
   c1.576,0.021,2.477,0.043,2.575,0.054v-0.077c20.937-0.151,100.407,0.858,127.94,23.828c-0.543,3.152-1.087,6.346-1.63,9.574
   l-0.251,0.5c-12.843,26.294-21.687,48.589-27.825,70.146c-5.173,18.092-6.367,37.009-7.52,55.295l-0.032,0.402
   c-1.153,18.265-1.771,42.667-2.37,66.267c-0.283,11.137-0.554,21.916-0.869,31.858C335.23,391.699,327.255,396.642,316.259,403.466
    M341.934,386.57c-0.216,6.715-0.456,13.038-0.749,18.785l-0.326,6.672c-1.771,0.966-19.124,9.984-56.956,13.331
   c13.321-9.256,24.055-15.917,32.727-21.295C327.386,397.391,335.253,392.513,341.934,386.57 M220.026,425.358
   c-37.834-3.347-55.176-12.365-56.956-13.331l-0.327-6.66c-0.283-5.759-0.52-12.082-0.749-18.797
   c6.681,5.943,14.548,10.821,25.315,17.493C195.981,409.442,206.716,416.102,220.026,425.358 M251.992,127.05
   c-15.853-0.218-101.331-0.239-130.656,23.719c-0.62-3.608-1.24-7.149-1.848-10.605c1.597-1.815,3.531-3.564,5.759-5.215
   c9.302-6.856,20.916-10.387,30.01-12.702c10.963-2.794,22.949-4.748,37.704-6.151c11.06-1.053,22.479-1.662,34.9-1.857
   c9.311-0.152,18.786-0.098,27.945-0.045c4.889,0.034,9.79,0.066,14.679,0.066h0.489c14.648,0,28.858,0.685,42.224,2.043
   c16.7,1.694,29.891,4.106,41.537,7.606c9.758,2.933,21.948,7.421,29.718,16.255c-0.61,3.455-1.229,6.996-1.858,10.605
   C353.312,126.842,267.984,126.832,251.992,127.05 M354.941,123.236c-11.691-3.511-24.937-5.943-41.67-7.638
   c-13.397-1.358-27.62-2.043-42.299-2.043c-5.04,0-10.104-0.034-15.157-0.065c-9.169-0.055-18.645-0.11-27.968,0.042
   c-12.44,0.197-23.871,0.804-34.954,1.859c-14.798,1.413-26.816,3.368-37.812,6.172c-9.149,2.324-20.862,5.889-30.259,12.821
   c-2.098,1.554-3.933,3.205-5.487,4.911c-0.891-5.043-1.76-9.877-2.587-14.409c0.522-0.716,1.076-1.433,1.717-2.161
   c0.663-0.761,1.391-1.521,2.173-2.249c15.559-14.625,44.939-18.907,62.499-21.459c42.254-6.15,90.692-5.607,143.987,1.641
   c17.645,2.39,44.332,6.019,58.337,22.068c0.651,0.728,1.206,1.445,1.717,2.161c-0.815,4.532-1.684,9.366-2.576,14.409
   C376.716,130.603,364.633,126.147,354.941,123.236 M48.286,289.173c1.228-6.661,2.401-13.364,3.554-19.851
   c4.193-23.829,8.159-46.331,14.614-69.561c7.192-25.838,16.809-53.489,26.413-75.883c4.77-11.137,11.269-21.351,14.766-26.839
   c1.315-2.063,2.075-3.28,2.478-4.019c0.596,3.128,2.934,15.341,5.899,31.705c-0.913,1.292-1.65,2.553-2.183,3.824
   c-31.141,74.375-42.191,156.603-42.778,161.048c-1.858,1-19.101,10.333-25.447,18.113l-0.825,1.01
   C45.917,302.233,47.081,295.692,48.286,289.173 M129.733,280.6c-4.563,16.352-9.29,33.259-10.745,41.299
   c-2.282,12.539-19.961,77.807-22.6,85.184c-3.152,8.802-11.854,60.651-11.92,61.13c-0.249,0.717-0.803,1.021-0.803,1.032
   c-7.204,1.717-24.187,2.912-56.979-8.41c-0.01-0.011-0.01-0.066,0-0.087c0,0-0.021,0.01-0.033,0.021l-0.065-0.347l0.349,0.021
   c1.413-21.654,3.357-47.264,7.117-72.971c1.489-10.137,2.465-20.438,3.421-30.401c0.5-5.248,1.012-10.681,1.598-16.016
   c0.456-4.14,1.304-8.324,2.119-12.376c0.488-2.401,0.988-4.889,1.413-7.346c0.618-3.693,1.271-7.442,1.922-11.191l1.619-1.987
   c6.596-8.073,25.209-17.917,25.403-18.015l0.164-0.087l0.021-0.185c0.11-0.848,10.92-85.054,42.745-161.048
   c0.436-1.031,1.012-2.075,1.706-3.128c2.076,11.452,4.434,24.827,6.715,38.474c1.012,10.996,5.369,58.814,9.366,107.328
   C131.439,274.483,130.581,277.536,129.733,280.6 M123.562,163.687c12.365,25.502,20.938,47.244,26.936,68.278
   c5.15,18.038,6.344,36.922,7.497,55.186l0.021,0.369c1.164,18.254,1.771,42.636,2.369,66.224
   c0.479,19.092,0.934,37.139,1.653,51.655l0.315,6.28c-3.444-1.586-22.612-10.735-22.643-17.972
   c0.118-3.422,0.26-6.801,0.413-10.094C141.306,357.885,125.43,184.039,123.562,163.687 M365.253,444.809
   c0,0.217-0.858,22.002-52.741,36.117c-22.981,4.64-45.754,5.323-72.897,4.9c-17.439-0.272-33.205-1.87-48.166-4.9
   c-51.914-14.114-52.762-35.899-52.772-36.106c0-0.283,0.141-24.643,0.945-48.613c3.629,7.726,21.959,15.908,22.948,16.354
   c0.5,0.283,18.156,10.169,58.597,13.593c0.033,0.021,0.064,0.043,0.087,0.054l0.033-0.043c8.432,0.706,17.818,1.14,28.271,1.14
   c0.782,0,1.597-0.01,2.391-0.01c0.815,0,1.63,0.01,2.434,0.01c10.451,0,19.84-0.434,28.261-1.14l0.033,0.043
   c0.032-0.011,0.054-0.034,0.086-0.054c40.442-3.424,58.098-13.31,58.598-13.593c0.989-0.445,19.329-8.627,22.948-16.354
   C365.122,420.177,365.253,444.526,365.253,444.809 M363.818,383.614c0.14,3.293,0.281,6.694,0.402,10.106
   c-0.066,7.247-19.199,16.374-22.633,17.961l0.304-6.28c0.716-14.516,1.172-32.554,1.651-51.643
   c0.598-23.589,1.218-47.982,2.369-66.235l0.023-0.391c1.161-18.265,2.358-37.138,7.496-55.165
   c5.999-21.034,14.581-42.776,26.947-68.278C378.496,184.039,362.622,357.885,363.818,383.614 M477.252,460.824
   c-32.792,11.333-49.784,10.137-56.913,8.442c-0.032-0.011-0.618-0.316-0.858-1.01c-0.087-0.523-8.779-52.371-11.94-61.173
   c-2.641-7.377-20.309-72.645-22.589-85.184c-1.468-8.052-6.193-24.969-10.758-41.332c-0.858-3.065-1.706-6.107-2.532-9.073
   c3.999-48.536,8.367-96.365,9.377-107.339c2.283-13.648,4.641-27.011,6.716-38.464c0.695,1.053,1.259,2.097,1.694,3.128
   c31.825,75.994,42.647,160.201,42.755,161.048l0.023,0.185l0.162,0.087c0.186,0.098,18.809,9.942,25.392,18.015l1.619,1.987
   c0.664,3.75,1.305,7.487,1.935,11.191c0.412,2.457,0.912,4.934,1.402,7.346c0.815,4.042,1.662,8.236,2.119,12.376
   c0.587,5.345,1.107,10.788,1.607,16.036c0.945,9.964,1.935,20.254,3.412,30.381c3.761,25.718,5.716,51.317,7.129,72.971
   l0.325-0.021l-0.087,0.326C477.264,460.769,477.252,460.824,477.252,460.824"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4889"
          strokeMiterlimit="10"
          strokeDasharray="1.4592,1.4581"
          d="
   M362.324,434.973c-0.024,0.272-0.209,1.791-1.303,4.122"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4889"
          strokeMiterlimit="10"
          strokeDasharray="1.4592,1.4581"
          d="
   M207.325,35.85c4.534-4.135,20.474-13.427,42.541-13.927l0.43,0.001c0.592-0.011,1.154-0.022,1.716-0.022l2.173,0.022
   c21.977,0.508,38.128,9.493,42.66,13.625"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4889"
          strokeMiterlimit="10"
          strokeDasharray="1.4592,1.4581"
          d="
   M361.021,439.096c-3.144,6.706-13.803,20.134-49.777,29.932c-17.171,3.469-35.032,4.95-59.705,4.95
   c-3.895,0-8.031-0.036-12.643-0.108c-17.326-0.269-32.933-1.854-47.71-4.843c-37.396-10.183-47.445-24.317-50.125-30.698"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4889"
          strokeMiterlimit="10"
          strokeDasharray="1.4592,1.4581"
          d="
   M141.609,402.208c6.074,5.729,16.293,10.626,19.988,12.292c1.6,0.881,19.667,10.388,58.834,13.766l2.041,0.171
   c8.672,0.687,17.774,1.037,27.08,1.037l2.401-0.011l2.422,0.011c9.301,0,18.407-0.35,27.091-1.037l1.225-0.104l0.977-0.079
   c39.06-3.392,57.079-12.877,58.673-13.753c3.758-1.696,13.929-6.581,19.985-12.293"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4889"
          strokeMiterlimit="10"
          strokeDasharray="1.4592,1.4581"
          d="
   M163.482,390.525c5.894,4.662,13.848,9.74,22.686,15.23l0.261,0.163c7.03,4.359,17.13,10.42,27.236,17.224"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4889"
          strokeMiterlimit="10"
          strokeDasharray="1.4592,1.4581"
          d="
   M160.021,408.634c-0.698-14.587-1.724-37.051-2.169-54.769c-0.595-23.524-1.211-47.846-2.356-65.995l-0.038-0.469
   c-1.137-18.018-2.312-36.65-7.33-54.236c-4.093-14.366-9.302-28.795-16.148-44.665l-5.924-13.391"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4889"
          strokeMiterlimit="10"
          strokeDasharray="1.4592,1.4581"
          d="
   M381.071,146.896c-28.672-19.854-95.375-22.059-123.445-22.059c-2.376,0-4.298,0.017-5.693,0.036
   c-1.331-0.018-3.251-0.036-5.611-0.036c-28.071,0-94.78,2.206-123.442,22.063"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4889"
          strokeMiterlimit="10"
          strokeDasharray="1.4592,1.4581"
          d="
   M121.817,140.845c1.341-1.421,2.928-2.81,4.733-4.139c8.974-6.632,20.344-10.087,29.248-12.356
   c10.868-2.765,22.743-4.701,37.373-6.092c10.999-1.05,22.359-1.654,34.728-1.847c3.865-0.064,8.09-0.095,12.92-0.095
   c4.624,0,9.233,0.027,13.775,0.054l1.193,0.007c4.399,0.029,8.799,0.057,13.192,0.057l2.036-0.002
   c14.589,0,28.714,0.683,41.977,2.032c16.571,1.682,29.642,4.073,41.133,7.524c9.188,2.763,20.582,6.935,28.007,14.855"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4889"
          strokeMiterlimit="10"
          strokeDasharray="1.4592,1.4581"
          d="
   M386.03,119.087c-15.043-15.375-41.068-18.91-58.499-21.279c-28.852-3.918-56.578-5.904-82.428-5.904
   c-21.956,0-42.944,1.435-62.38,4.264c-17.884,2.601-47.816,6.953-64.053,22.212c-0.249,0.231-0.5,0.473-0.754,0.726"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4889"
          strokeMiterlimit="10"
          strokeDasharray="1.4592,1.4581"
          d="
   M82.947,458.211c-2.739,0.578-5.965,0.871-9.604,0.871c-11.691,0-26.362-2.954-43.63-8.784"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4889"
          strokeMiterlimit="10"
          strokeDasharray="1.4592,1.4581"
          d="
   M113.928,124.238c-0.796,1.217-1.416,2.359-1.881,3.469c-29.898,71.391-41.327,149.856-42.78,160.501
   c-3.83,2.094-13.988,7.869-20.893,13.863"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4889"
          strokeMiterlimit="10"
          strokeDasharray="1.4592,1.4581"
          d="
   M340.36,390.525c-5.895,4.662-13.847,9.74-22.685,15.23l-0.261,0.163c-7.03,4.359-17.13,10.42-27.236,17.224"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4889"
          strokeMiterlimit="10"
          strokeDasharray="1.4592,1.4581"
          d="
   M343.821,408.634c0.698-14.587,1.725-37.051,2.17-54.769c0.595-23.524,1.212-47.846,2.356-65.995l0.038-0.469
   c1.137-18.018,2.312-36.65,7.33-54.236c4.093-14.366,9.302-28.795,16.148-44.665l5.924-13.391"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4889"
          strokeMiterlimit="10"
          strokeDasharray="1.4592,1.4581"
          d="
   M420.894,458.211c2.739,0.578,5.965,0.871,9.604,0.871c11.691,0,26.362-2.954,43.63-8.784"
        />
        <path
          fill="none"
          stroke={stitching}
          onClick={() => handleClick("stitching")}
          onMouseEnter={() => setStitchingActive(true)}
          onMouseLeave={() => setStitchingActive(false)}
          style={
            stitchingActive && !preview
              ? {stroke: adjust(stitching, 55)}
              : {stroke: stitching}
          }
          strokeWidth="0.4889"
          strokeMiterlimit="10"
          strokeDasharray="1.4592,1.4581"
          d="
   M389.915,124.238c0.796,1.217,1.416,2.359,1.881,3.469c29.898,71.391,41.327,149.856,42.78,160.501
   c3.83,2.094,13.988,7.869,20.893,13.863"
        />
      </g>
    </svg>
  );
}
